import script from "./SandboxView.vue?vue&type=script&setup=true&lang=js"
export * from "./SandboxView.vue?vue&type=script&setup=true&lang=js"

import "./SandboxView.vue?vue&type=style&index=0&id=6fdb22b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fdb22b0"]])

export default __exports__